import { OnInit, Component } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';

import { environment } from '../../environments/environment';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

declare var $:any;

@Component({
  selector: 'app-friends',
  templateUrl: './friends.component.html',
  styleUrls: ['./friends.component.scss']
})
export class FriendsComponent implements OnInit {
  private Parse: any = require('parse');

  model: any = {};
  headers = new Headers();
  searchTerm: string;
  searchResults: any;
  userId: string = this.apiService.Parse.User.current().id;
  following: any = [];

  constructor(
    private http: Http,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService
  ) {
    // Set the HTTP headers
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('X-Parse-Application-Id', environment.parse.appId);
    this.headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      this.headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }
  }

  ngOnInit() {
    this.loaderService.setLoading();

    this.route.queryParams.subscribe(response => {
      if (response.q) {
        this.searchTerm = response.q;
        this.searchUsers(this.searchTerm);
      }
    });

    let options = new RequestOptions({ headers: this.headers });

    return this.http.get(this.apiService.Parse.serverURL + '/users/' + this.apiService.Parse.User.current().id, options)
    .map(response => response.json()).subscribe(
      response => {
        this.getFollowing();
        this.loaderService.setLoaded();
      },
      // error => console.log(error),
      () => {
        this.loaderService.setLoaded();
      }
    );
  }

  getFollowing() {
    let params = new URLSearchParams();

    // Configure the params to retrieve the following relations
    params.append("where", '{"$relatedTo":{"object":{"className":"_User","__type":"Pointer","objectId":"' + this.userId + '"},"key":"following"}}');

    let options = new RequestOptions({ headers: this.headers, params: params });

    // Get the friends list
    return this.http.get(this.apiService.Parse.serverURL + '/users', options)
      .map(response => response.json()).subscribe(
      response => {
        Object.assign(this.model, response);

        // Push the `objectId` of already followed users, so we can affect the state of the follow/un-follow button in search results
        for (let i = 0; i < response.results.length; i++) {
          this.following.push(response.results[i].objectId);
        }
      },
      // error => console.log(error),
      () => {
        this.loaderService.setLoaded();
      }
    );
  }

  onClick(event, userId) {
    let target = event.target.tagName.toLowerCase();

    if (target != 'button') {
      this.router.navigate(['/home', userId]);
    }
  }

  searchUsers(searchTerm) {
    let params = new URLSearchParams();
    let where: any;

    if (searchTerm != undefined && searchTerm.indexOf(' ') >= 0) {
      let formattedSearchTerms: any = [];

      for (let i = 0; i < searchTerm.split(' ').length; i++) {
        // Convert to lowercase
        formattedSearchTerms.push(searchTerm.split(' ')[i].toLowerCase());
        // // Convert to uppercase
        formattedSearchTerms.push(searchTerm.split(' ')[i].toUpperCase());
        // // Convert to titlecase
        formattedSearchTerms.push(searchTerm.split(' ')[i].toLowerCase().charAt(0).toUpperCase() + searchTerm.split(' ')[i].slice(1));
      }

      where = {
        firstName: {
          $in: formattedSearchTerms
        },
        lastName: {
          $in: formattedSearchTerms
        }
      }
    } else {
      where = {
        $or: [
          {
            displayName: {
              $regex: ".*" + searchTerm + ".*"
            }
          },
          {
            firstName: {
              $regex: ".*" + searchTerm + ".*"
            }
          },
          {
            lastName: {
              $regex: ".*" + searchTerm + ".*"
            }
          },
          {
            vanityName: {
              $regex: ".*" + searchTerm + ".*"
            }
          }
        ]
      }
    }

    params.append('where', JSON.stringify(where));

    let options = new RequestOptions({ headers: this.headers, params: params });

    return this.http.get(this.apiService.Parse.serverURL + '/users', options)
    .map(response => response.json()).subscribe(
      response => {
        // Navigate to the friends route with the search term as a query parameter
        this.router.navigate(['/friends'], {
          queryParams: {
            q:searchTerm
          }
        });

        this.searchResults = response.results;
      },
      // error => console.log(error),
      () => {}
    );
  }

  followUser(userId) {
    let payload = {
      "following": {
        "__op": "AddRelation",
        "objects": [{
          "__type": "Pointer",
          "className": "_User",
          "objectId": userId
        }]
      }
    };

    let options = new RequestOptions({ headers: this.headers });

    return this.http.put(this.apiService.Parse.serverURL + '/users/' + this.apiService.Parse.User.current().id, payload, options)
    .map(response => response.json()).subscribe(
      response => {
        this.getFollowing();
      },
      // error => console.log(error),
      () => {}
    );
  }

  unFollowUser(userId) {
    let payload = {
      "following": {
        "__op": "RemoveRelation",
        "objects": [{
          "__type": "Pointer",
          "className": "_User",
          "objectId": userId
        }]
      }
    };

    let options = new RequestOptions({ headers: this.headers });

    return this.http.put(this.apiService.Parse.serverURL + '/users/' + this.apiService.Parse.User.current().id, payload, options)
    .map(response => response.json()).subscribe(
      response => {
        this.getFollowing();
      },
      // error => console.log(error),
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/friends/friends.component.ts